import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { englishTranslations } from './defaultTranslations/en';
import { ltTranslations } from './defaultTranslations/lt';
import { russianTranslations } from './defaultTranslations/ru';
import { ContributionCountElement as cce } from './types/ContributionCountElement';
/** @internal */
function calculateOrder(input) {
    switch (input) {
        case 5 /* DATE_TEXT_COUNT */:
            return [cce.DATE, cce.TEXT, cce.COUNT];
        case 1 /* COUNT_DATE_TEXT */:
            return [cce.COUNT, cce.DATE, cce.TEXT];
        case 2 /* TEXT_COUNT_DATE */:
            return [cce.TEXT, cce.COUNT, cce.DATE];
        case 3 /* TEXT_DATE_COUNT */:
            return [cce.TEXT, cce.DATE, cce.COUNT];
        case 4 /* DATE_COUNT_TEXT */:
            return [cce.DATE, cce.COUNT, cce.TEXT];
        default:
            return [cce.COUNT, cce.TEXT, cce.DATE];
    }
}
/** A basic UI translator */
var Translator = (function () {
    function Translator() {
        this.registerTranslations(englishTranslations);
    }
    Object.defineProperty(Translator.prototype, "hideZero", {
        /** Whether or not the number 0 should be hidden if there are no contributions on the given day */
        get: function () {
            return this.result.hideZero;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register custom translations
     * @param tr The translations
     */
    Translator.prototype.registerTranslations = function (tr) {
        if (tr !== this.previousRegistration) {
            this.previousRegistration = tr;
            this.result = Object.assign({}, englishTranslations, tr || {});
            this.order = calculateOrder(this.result.order);
            Object.freeze(this.order);
        }
    };
    /**
     * Set a predefined locale
     * @param locale The locale
     * @throws {Error} If the locale is unknown
     */
    Translator.prototype.setLocale = function (locale) {
        switch (locale) {
            case 'en':
                this.registerTranslations(englishTranslations);
                break;
            case 'ru':
                this.registerTranslations(russianTranslations);
                break;
            case 'lt':
                this.registerTranslations(ltTranslations);
                break;
            default:
                throw new Error("Unknown locale: " + locale);
        }
    };
    /**
     * Translate a string
     * @param key The code/id to translate
     * @param qty If the translation is countable, the quantity
     * @returns The translated string
     * @throws {Error} If the key is unknown
     */
    Translator.prototype.translate = function (key, qty) {
        var tr = this.result[key];
        if (!tr) {
            throw new Error("Unknown translation key: " + key);
        }
        if (typeof tr === 'string') {
            return tr;
        }
        else if (tr[qty]) {
            return tr[qty];
        }
        else if (tr.other) {
            return tr.other;
        }
        throw new Error("Unable to find translation for key " + key + " qty " + qty);
    };
    Translator = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [])
    ], Translator);
    return Translator;
}());
export { Translator };



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Translate/Translator.ts
// module id = 2
// module chunks = 0 1